import ReactStrapTable from 'components/reactStrapTable'
import React, {useState, useEffect} from 'react'
import { cellRendererCheck, currencyFormat, dateFormate } from 'utils/columns';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import HoverImage from 'react-hover-image/build';
import { ModuleAccess } from 'utils/moduleaccess';
import { Button } from 'reactstrap';
import ViewPo from "assets/icon/ViewPo.svg";
import ViewPoHover from "assets/icon/ViewPoHower.svg";


const ConfigurationsTable = ({
  tenantID,
  data,
  loading,
  AllExport,
  slelectedExportcoloumms,
  filters,
  totalSize,
  toggleSider,
  collapseSider,
  onPageChange,
  refetch,
  setClientCongigToggle,
  setRowConfig,
  onExport,
  setLoading,
  onSearchColumnFilters,
  thirdPartyAdmin,
  setConfigRules,
  reset,
  tableData,
  SelectedRow,
  editConfigtoggle,
  setEditConfigToggle,
  setSelectedRow
}
) => {
  const [hasExportPermission, setHasExportPermission] = useState(false);
  useEffect(() => {
    setHasExportPermission(ModuleAccess("CONFIG", "EXP"));
  }, []);

  let mainCol = [
    {
      dataField: 'options',
      text: 'Options',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      action: true,
    },
    {
      dataField: 'tpaName',
      text: 'TPA',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'coveredEntityName',
      text: 'Covered Entity',
      width: 300,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: false,
    },
     {
      dataField:'opaCode',
      text: 'OPA Code',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: false,
    },
    {
      dataField: 'pharmacyName',
      text: 'Pharmacy',
      width: 288,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: false,
    },
    {
      dataField: 'npi',
      text: 'Pharmacy NPI',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: false,
    },
    {
      dataField: 'contractStatus',
      text: 'Contract Status',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
   

    {
      dataField: 'effectiveStartDate',
      text: 'Contract Live Date',
      //sort: true,
      width: 144,
      show: true,
      inputType: 'date',
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: 'effectiveEndDate',
      text: 'Contract Term Date',
      //sort: true,
      width: 144,
      show: true,
      inputType: 'date',
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: 'dispenseFees',
      text: 'Cash Dispense Fee',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'wholesaler',
      text: 'Wholesaler Name',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'wholesalerAccount',
      text: '340B Account #',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'orderingStatus',
      text: 'Ordering Status',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'orderingStartDate',
      text: 'Ordering Start Date',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      hideColFilter: true,
    },
  ];
  const renderConfigButton = (rowData) => {
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => handleConfig(rowData)}
        title="Client Configuration"
      >
        <HoverImage src={ConfigIcon} hoverSrc={ConfigIconHover} alt="" />
      </Button>
    );
  };
  const renderViewButton = (rowData) => {
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => handleConfig(rowData)}
        title="View Configurations"
      >
        <HoverImage src={ViewPo} hoverSrc={ViewPoHover} alt="" />
      </Button>
    );
  };

  const cellRenderEdit = (rowData) => {
    return (
      <div className="d-flex align-items-center">
        {/* {renderEditButton(rowData)} */}
        {renderConfigButton(rowData)}
        {/* {renderCommentsButton(rowData)} */}
        {/* {renderViewButton(rowData)} */}
      </div>
    );
  };

  const handleConfig = async (rowData) => {
    setClientCongigToggle(true);
    setEditConfigToggle(false);
    setSelectedRow(rowData)
    setRowConfig(false);
    setConfigRules(false)
    //await manvalConfigview(rowData);
  };
  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };
  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
    }
  };
  const handleFilterCancel = () => {
    refetch();
  };
  return (
    <div>

      <div>
        <h5 className="f-16 text-primary font-weight-700">
          Configurations Count ({totalSize})
        </h5>
        <hr />
        <div
          className="table-card scroll-table position-relative border-0 rounded pt-0"
          fixed-height={data.length > 0 ? "fixed-height" : "default"}
        >
          <ReactStrapTable
            id='inventory-table'
            height={550}
            fixedColumn
            width={1200}
            reset={reset}
            hasPagination
            loading={loading}
            data={data}
            columns={mainCol}
            AllExport={AllExport}
            slelectedExport={slelectedExportcoloumms}
            filters={filters}
            totalRecords={totalSize}
            pageSize={filters.pageSize}
            currentPage={filters.currentPage}
            onExport={onExport}
            // handleSort={onHandleSort}
            onPageChange={onHandlePageChange}
            onPageSizeChange={onPageSizeChange}
            onFilterCancel={handleFilterCancel}
            onSearchColumnFilters={handleSearchColumnFilters}
            // hasColselect={true}
            // onSelectColoums={handleselectColoums}
            hasExportPermission={hasExportPermission}
            // disableSelectedColumn={disableSelectedColumn}
            // autoselectlist1={autoselectlist1}
            collapseSider={collapseSider}
            enabletogglesider={true}
            toggleSider={toggleSider}
          >
          </ReactStrapTable>
        </div>
      </div>
    </div>
  )
}

export default ConfigurationsTable